/** Stable AI chat session ID for the lifetime of this browser tab — generated once at module load. */
export const AI_SESSION_ID = crypto.randomUUID();
